<template>
  <v-container>
    <h2>Active Users</h2>
    <br>
    <v-progress-linear v-if="loading" indeterminate color="teal"/>
    <v-text-field class="ma-auto" v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details @change="searchUser"/>
    <br>
    <v-data-table dense :headers="headers" :items="users" :items-per-page=10000 hide-default-footer>
      <template v-slot:item.country="{ item }">
        <country-flag v-if="item.country" :country='item.country'/>
      </template>
      <template v-slot:item.registrationDate="{ item }">
        <div>{{ item.registrationDate | formatDate}}</div>
      </template>
      <template v-slot:item.enabled="{ item }">
        <v-simple-checkbox disabled :value="item.enabled === true" v-ripple="false"></v-simple-checkbox>
      </template>
    </v-data-table>
    <br>
    <v-pagination v-model="pageNumber" :length="totalPages" :total-visible="10" @input="getPage" @next="getNextPage" @previous="getPreviousPage" />
  </v-container>
</template>

<script>

import {eSailServerAuth} from "@/plugins/axios";

export default {
  name: "Users",
  data: () => ({
    headers: [
      { text: 'Username', value: 'username' },
      { text: 'Email', value: 'email' },
      { text: 'Boat Name', value: 'boatName' },
      { text: 'User Id', value: 'id' },
      { text: 'eSail Version', value: 'esailVersion' },
      { text: 'Registered', value: 'registrationDate' },
      { text: 'Active', value: 'enabled' },
      { text: 'Country', value: 'country' }
    ],
    loading: false,
    search: '',
    users: [],
    selectedUser: null,
    pageNumber: 1,
    totalPages: 1
  }),
  mounted() {
    this.getPage(this.pageNumber)
  },
  methods: {
    getPage() {
      this.loading = true
      const params = new URLSearchParams([['searchText', this.search], ['size', 10], ['page', this.pageNumber - 1]])
      eSailServerAuth.get('admin/users', { headers: { Authorization: `Bearer ` + this.$auth.token() }, params})
          .then(response => {
            const resp =  response.data
            this.users = resp.content
            this.pageNumber = resp.number + 1
            this.totalPages = resp.totalPages
            this.loading = false
          })
    },
    getNextPage() {
      if (this.pageNumber < this.totalPages) {
        this.pageNumber++
      }
    },
    getPreviousPage() {
      if (this.pageNumber > 0) {
        this.pageNumber--
      }
    },
    searchUser() {
      this.pageNumber = 1
      this.getPage()
    }
  }
}

</script>

<style scoped>

</style>